import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {GrCity} from '../../../../../interfaces/general-interfaces';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BankAccountRegex, DigitRegex, MbRegex, MobileRegex, PhoneRegex, PibRegex, TimeRegex} from '../../../../../constants/general-variables';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {GeneralHttpService} from '../../../../../services/http-services/general/general-http.service';
import {BusinessProfilesHttpService} from '../../../../../services/http-services/business-profiles/business-profiles-http.service';
import {PAGES_AND_PATHS} from '../../../../../constants/pages-and-paths';
import {arrayNotEmpty, timeRangeValidator} from '../../../../../validators/form-validators.validator';
import {GeneralHelperService} from '../../../../../services/helpers/general-helper.service';
import {pairwise, startWith} from 'rxjs';
import {DatePipe} from "@angular/common";

interface Image360Item {
  fullPath: string;
  file: File;
}

@Component({
  selector: 'gr-base-data',
  templateUrl: './base-data.component.html',
})
export class BaseDataComponent implements OnInit, OnChanges {
  listOfCities: GrCity[] = [];
  listOfPictograms: any[] = [];
  listOfMunicipalities: any[] = [];
  isBusinessProfileFormDisabled = true;
  editBusinessProfileForm!: FormGroup;
  formTriedToSubmit = false;
  urlParams = {companyId: null};
  imageUrls: any[] = [];
  deletedImagesIds: number[] = [];
  isDisabledBusinessCategory = false;
  isLoaderActive = false;
  @Input() businessProfileData: any;
  @Input() listOfCategories: any[] = [];
  @Input() isNewBusiness = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  isChecked = false;
  selectedDate: Date | null = null;
  showError = false;
  selectedVideo: File | null = null;
  selected360File: any;
  preview360Url?: string;
  image360Urls: Image360Item[] = [];
  videosUrls: any[] = [];
  error360?: string;

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private toastService: ToastrService,
              private generalHelper: GeneralHelperService,
              private generalHttpService: GeneralHttpService,
              private businessProfilesHttpService: BusinessProfilesHttpService,
              private datePipe: DatePipe,
              ) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.activatedRoute.params.subscribe((res: any) => {
      this.urlParams.companyId = res.id;
    });
    this.getCities();
    this.editBusinessProfileForm.controls.business_category_id.valueChanges
      .pipe(
        startWith(this.editBusinessProfileForm.controls.business_category_id.value),
        pairwise()
      )
      .subscribe(([prevValue, currentValue]) => {
        if (prevValue !== currentValue) {
          if (currentValue) {
            this.getPictograms({categoryId: currentValue});
          }

          const workingMunicipalities = this.editBusinessProfileForm.get('workingMunicipalities');
          if (currentValue && currentValue === 1) {
            workingMunicipalities?.clearValidators();
            this.editBusinessProfileForm.addControl('age_range_from', this.formBuilder.control('', Validators.required));
            this.editBusinessProfileForm.addControl('age_range_to', this.formBuilder.control('', Validators.required));
            this.editBusinessProfileForm.addControl('children_capacity', this.formBuilder.control('', Validators.required));
            this.editBusinessProfileForm.addControl('adult_capacity', this.formBuilder.control('', Validators.required));
            this.editBusinessProfileForm.addControl('down_payment', this.formBuilder.control('', Validators.required));
          } else {
            workingMunicipalities?.setValidators(arrayNotEmpty);
            this.editBusinessProfileForm.removeControl('age_range_from');
            this.editBusinessProfileForm.removeControl('age_range_to');
            this.editBusinessProfileForm.removeControl('children_capacity');
            this.editBusinessProfileForm.removeControl('adult_capacity');
            this.editBusinessProfileForm.removeControl('down_payment');
          }
          if (currentValue && (currentValue === 3 || currentValue === 6)) {
            this.editBusinessProfileForm.addControl('max_order_quantity', this.formBuilder.control('', [Validators.required, Validators.pattern(DigitRegex)]));
            this.editBusinessProfileForm.addControl('delivery_price', this.formBuilder.control('', Validators.required));
          } else {
            this.editBusinessProfileForm.removeControl('max_order_quantity');
            this.editBusinessProfileForm.removeControl('delivery_price');
          }
          workingMunicipalities?.updateValueAndValidity();
        }
      });

    this.editBusinessProfileForm.controls.business_location_id.valueChanges
      .pipe(
        startWith(this.editBusinessProfileForm.controls.business_category_id.value),
        pairwise()
      )
      .subscribe(([prevValue, currentValue]) => {
        if (prevValue !== currentValue) {
          if (currentValue) {
            this.getMunicipalities(currentValue);
          } else {
            this.editBusinessProfileForm.controls.municipality_id.setValue('');
          }
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.businessProfileData && changes.businessProfileData.currentValue) {
      this.editBusinessProfileForm?.patchValue(changes.businessProfileData.currentValue);
      this.promoCodes.clear();
      this.businessProfileData = changes.businessProfileData.currentValue;
      if (changes.businessProfileData.currentValue.promo_codes?.length) {
        // postoje promo kodovi → prikazujemo postojeće
        changes.businessProfileData.currentValue.promo_codes.forEach((pc: any) => this.addPromoCode(pc));
      } else {
        // nema promo kodova → prikaži odmah jedan prazan
        // this.addPromoCode();
      }

      const initialSelectedPictograms = changes.businessProfileData.currentValue.pictograms.map((pictogram: any) => {
        return pictogram.id;
      });
      if (changes.businessProfileData.currentValue.business_category_id && changes.businessProfileData.currentValue.business_category_id !== 1) {
        const initialSelectedWorkingMunicipalities = changes.businessProfileData.currentValue.working_municipalities.map((element: any) => {
          return element.id;
        });
        this.editBusinessProfileForm?.controls.workingMunicipalities.patchValue(initialSelectedWorkingMunicipalities);
        this.editBusinessProfileForm.get('workingMunicipalities')?.setValidators(arrayNotEmpty);
      }
      if (changes.businessProfileData.currentValue.business_category_id && changes.businessProfileData.currentValue.business_category_id === 1) {
        this.editBusinessProfileForm.addControl('age_range_from', this.formBuilder.control('', Validators.required));
        this.editBusinessProfileForm.addControl('age_range_to', this.formBuilder.control('', Validators.required));
        this.editBusinessProfileForm.addControl('children_capacity', this.formBuilder.control('', Validators.required));
        this.editBusinessProfileForm.addControl('adult_capacity', this.formBuilder.control('', Validators.required));
        this.editBusinessProfileForm.addControl('down_payment', this.formBuilder.control('', Validators.required));
      }
      if (changes.businessProfileData.currentValue.business_category_id && (changes.businessProfileData.currentValue.business_category_id === 3 || changes.businessProfileData.currentValue.business_category_id === 6)) {
        this.editBusinessProfileForm.addControl('max_order_quantity', this.formBuilder.control('', [Validators.required, Validators.pattern(DigitRegex)]));
        this.editBusinessProfileForm.addControl('delivery_price', this.formBuilder.control('', Validators.required));
      }
      this.imageUrls = changes.businessProfileData.currentValue.images.map((item: any) => {
        return {fullPath: item.full_path, id: item.id, file: undefined};
      });
      this.image360Urls = changes.businessProfileData.currentValue.images_360.map((item: any) => {
        return {fullPath: item.full_path, id: item.id, file: undefined};
      });
      this.videosUrls = changes.businessProfileData.currentValue.videos.map((item: any) => {
        return {fullPath: item.full_path, id: item.id, file: undefined, poster: item.poster};
      });
      this.editBusinessProfileForm?.controls.pictograms_ids.patchValue(initialSelectedPictograms);
      this.editBusinessProfileForm?.controls.time_start.patchValue(changes.businessProfileData.currentValue.time_start?.slice(0, -3));
      this.editBusinessProfileForm?.controls.time_end.patchValue(changes.businessProfileData.currentValue.time_end?.slice(0, -3));
      this.editBusinessProfileForm?.controls.weekend_time_start.patchValue(changes.businessProfileData.currentValue.weekend_time_start?.slice(0, -3));
      this.editBusinessProfileForm?.controls.weekend_time_end.patchValue(changes.businessProfileData.currentValue.weekend_time_end?.slice(0, -3));
      if (changes.businessProfileData.currentValue.business_category_id) {
        this.isDisabledBusinessCategory = true;
      }
      this.editBusinessProfileForm?.controls.images.patchValue(changes.businessProfileData.currentValue.images?.length ? changes.businessProfileData.currentValue.images : null);
      this.initInnerForm(changes.businessProfileData.currentValue);
      if (this.businessProfileData.promotion_active) {
        this.editBusinessProfileForm.get('rebate')?.disable();
      }
      this.disabledBusinessProfileForm();
    }
  }

  buildForm(): void {
    this.editBusinessProfileForm = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      phone_number: ['', Validators.pattern(PhoneRegex)],
      mobile_number: ['', [Validators.required, Validators.pattern(MobileRegex)]],
      identification_number: ['', [Validators.required, Validators.pattern(PibRegex)]],
      tax_identification_number: ['', [Validators.required, Validators.pattern(MbRegex)]],
      bank_account_number: ['', [Validators.required, Validators.pattern(BankAccountRegex)]],
      business_location_id: ['', Validators.required],
      municipality_id: ['', Validators.required],
      workingMunicipalities: [[]],
      rebate: ['', Validators.required],
      active: [false],
      highlighted: [false],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required],
      description: ['', Validators.required],
      time_start: ['', [Validators.required, timeRangeValidator]],
      time_end: ['', [Validators.required, timeRangeValidator]],
      weekend_time_start: ['', [timeRangeValidator]],
      weekend_time_end: ['', [timeRangeValidator]],
      business_category_id: ['', Validators.required],
      pictograms_ids: [[]],
      images: [null, Validators.required],
      deleted_images_ids: [[]],
      promo_codes: this.formBuilder.array([]),
      videos: [[]],
      images_360: [[]],
      note: [''],
    });
  }

  enableBusinessProfileForm(): void {
    this.isBusinessProfileFormDisabled = false;
    this.editBusinessProfileForm.enable();
  }

  disabledBusinessProfileForm(): void {
    this.isBusinessProfileFormDisabled = true;
    this.editBusinessProfileForm.disable();
  }

  getCities(): void {
    this.generalHttpService.getCities().then(res => {
      this.listOfCities = res.data;
    });
  }

  getPictograms(categoryId: any): void {
    this.generalHttpService.getPictograms(categoryId).then(res => {
      this.listOfPictograms = res.data;
    });
  }

  getMunicipalities(cityId: number): void {
    this.generalHttpService.getMunicipalities({id: cityId}).then((res: any) => {
      this.listOfMunicipalities = res.data.municipalities;
    });
  }

  formatOnBlur(): void {
    const value = this.editBusinessProfileForm.get('rebate')?.value || '';
    this.editBusinessProfileForm.get('rebate')?.setValue(parseFloat(value).toFixed(2));
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const selectedFiles = Array.from(input.files);
      selectedFiles.forEach(file => {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
          this.toastService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
          return;
        } else if (file?.size > 10485760) {
          this.toastService.warning(`Slika ${file.name} je veća od 10MB.`);
          return;
        }
        this.imageUrls.push({fullPath: URL.createObjectURL(file), id: undefined, file});
      });
      this.editBusinessProfileForm.controls.images.patchValue(this.imageUrls);
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    }
  }

  removeAllImages(): void {
    this.imageUrls.forEach((image: any) => {
      if (image.id) {
        this.deletedImagesIds.push(image.id);
      }
    });
    this.imageUrls = [];
    this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
    this.editBusinessProfileForm.controls.images.patchValue(null);
  }

  removeAll360Images(): void {
    this.image360Urls.forEach((image: any) => {
      if (image.id) {
        this.deletedImagesIds.push(image.id);
      }
    });
    this.image360Urls = [];
    this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
    this.editBusinessProfileForm.controls.images_360.patchValue(null);
  }

  removeAllVideos(): void {
    this.videosUrls.forEach((video: any) => {
      if (video.id) {
        this.deletedImagesIds.push(video.id);
      }
    });
    this.videosUrls = [];
    this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
    this.editBusinessProfileForm.controls.videos.patchValue(null);
  }

  removeSingleImage(imageURL: any): void {
    if (!this.isBusinessProfileFormDisabled) {
      const imageIndex = this.imageUrls.findIndex((imgUrl: any) => {
        return imgUrl.fullPath === imageURL.fullPath;
      });
      if (imageIndex !== -1) {
        if (imageURL.id) {
          this.deletedImagesIds.push(imageURL.id);
        }
        this.imageUrls.splice(imageIndex, 1);
        this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
        this.editBusinessProfileForm.controls.images.patchValue(this.imageUrls.length ? this.imageUrls : null);
      }
    }
  }

  removeSingle360Image(imageURL: any): void {
    if (!this.isBusinessProfileFormDisabled) {
      const imageIndex = this.image360Urls.findIndex((imgUrl: any) => {
        return imgUrl.fullPath === imageURL.fullPath;
      });
      if (imageIndex !== -1) {
        if (imageURL.id) {
          this.deletedImagesIds.push(imageURL.id);
        }
        this.image360Urls.splice(imageIndex, 1);
        this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
        this.editBusinessProfileForm.controls.images_360.patchValue(this.image360Urls.length ? this.image360Urls : null);
      }
    }
  }

  removeSingleVideo(videoURL: any): void {
    if (!this.isBusinessProfileFormDisabled) {
      const videoIndex = this.videosUrls.findIndex((vidUrl: any) => {
        return vidUrl.fullPath === videoURL.fullPath;
      });
      if (videoIndex !== -1) {
        if (videoURL.id) {
          this.deletedImagesIds.push(videoURL.id);
        }
        this.videosUrls.splice(videoIndex, 1);
        this.editBusinessProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
        this.editBusinessProfileForm.controls.videos.patchValue(this.videosUrls.length ? this.videosUrls : null);
      }
    }
  }

  submitEditBusinessProfileForm(): void {
    this.formTriedToSubmit = true;
    if (this.editBusinessProfileForm.valid) {
      this.isLoaderActive = true;
      const formData: FormData = new FormData();

      for (const key in this.editBusinessProfileForm.value) {

        // // 🔹 NOVO – VIDEO
        // if (key === 'video' && this.editBusinessProfileForm.value[key] instanceof File) {
        //   if (!this.businessProfileData.video) {
        //     const video: File = this.editBusinessProfileForm.value[key];
        //     formData.append('video', video, video.name);
        //     continue;
        //   }
        // }
        //
        // if (key === '360') {
        //   formData.append("image_360", this.selected360File);
        //   continue;
        // }

        if (Array.isArray(this.editBusinessProfileForm.value[key])) {
          if (key === 'images') {
            this.editBusinessProfileForm.value[key].forEach((element: any, index: number) => {
              formData.append(`images[${index}][position]`, (index + 1).toString());
              (element.id)
                ? formData.append(`images[${index}][id]`, element.id.toString())
                : formData.append(`images[${index}][file]`, element.file);
            });
          } else if (key === 'promo_codes') {
            this.editBusinessProfileForm.value.promo_codes.forEach((pc: any, index: number) => {
              if (pc.id) {
                formData.append(`promo_codes[${index}][id]`, pc.id);
              }
              formData.append(`promo_codes[${index}][code]`, pc.code);
              formData.append(`promo_codes[${index}][discount]`, pc.discount);
              formData.append(`promo_codes[${index}][status]`, pc.status ? '1' : '0');
            });
            continue;
          } else if (key === 'images_360') {
            this.image360Urls.forEach((element: any, index: number) => {
              formData.append(`images_360[${index}][position]`, (index + 1).toString());
              (element.id)
                ? formData.append(`images_360[${index}][id]`, element.id.toString())
                : formData.append(`images_360[${index}][file]`, element.file);
            });
            continue;
          } else if (key === 'videos') {
            this.videosUrls.forEach((element: any, index: number) => {
              formData.append(`videos[${index}][position]`, (index + 1).toString());
              (element.id)
                ? formData.append(`videos[${index}][id]`, element.id.toString())
                : formData.append(`videos[${index}][file]`, element.file);
            });
          } else {
            this.editBusinessProfileForm.value[key].forEach((element: any) => {
              formData.append(`${key}[]`, element);
            });
          }
        } else if (this.editBusinessProfileForm.value[key] !== null && this.editBusinessProfileForm.value[key] !== undefined) {
          // 🎥 VIDEO
          // if (key === 'video') {
          //   // novi video → šaljemo
          //   if (this.editBusinessProfileForm.value[key] instanceof File) {
          //     const video: File = this.editBusinessProfileForm.value[key];
          //     formData.append('video', video, video.name);
          //   }
          //   // video već postoji → NE šaljemo ništa
          //   continue;
          // }
          // 🧾 OSTALA POLJA
          formData.append(key, this.editBusinessProfileForm.value[key]);
        }
      }

      formData.forEach((value, key) => {
        console.log('key, value', key, value);
      });

      this.businessProfilesHttpService.postBusinessProfile(this.urlParams, formData).then(res => {
        this.disabledBusinessProfileForm();
        this.businessProfileData.video = res.data.video;
        this.editBusinessProfileForm.controls.deleted_images_ids.patchValue([]);
        this.deletedImagesIds = [];
        this.imageUrls = res.data.images.map((item: any) => {
          return { fullPath: item.full_path, id: item.id, file: undefined };
        });
        this.image360Urls = res.data.images_360.map((item: any) => {
          return { fullPath: item.full_path, id: item.id, file: undefined };
        });
        this.videosUrls = res.data.videos.map((item: any) => {
          return { fullPath: item.full_path, id: item.id, file: undefined, poster: item.poster };
        });
        this.editBusinessProfileForm.controls.images.patchValue(this.imageUrls);
        this.editBusinessProfileForm.controls.images_360.patchValue(this.image360Urls);
        this.editBusinessProfileForm.controls.videos.patchValue(this.videosUrls);
        this.isLoaderActive = false;
        this.toastService.success(res.message);
        if (this.isNewBusiness) {
          this.generalHelper.setChangeSomeBusinessProfile({
            categoryId: this.editBusinessProfileForm.controls.business_category_id.value,
            businessId: this.urlParams.companyId
          });
        }
      }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
        this.isLoaderActive = false;
        Object.values(error.errors).forEach(error => this.toastService.error(error));
      });
    }
  }

  onVideoSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const files = Array.from(input.files);
    console.log('files', files)

    files.forEach(file => {
      const objectUrl = URL.createObjectURL(file);
      this.videosUrls.push({
        fullPath: objectUrl,
        file
      });
    });
    this.editBusinessProfileForm.controls.videos.patchValue(this.videosUrls);
  }

  get promoCodes(): FormArray {
    return this.editBusinessProfileForm.get('promo_codes') as FormArray;
  }

  addPromoCode(existing?: any) {
    this.promoCodes.push(
      this.formBuilder.group({
        id: [existing?.id || null],
        code: [
          existing?.code || '',
          [Validators.required, Validators.minLength(4)]
        ],
        discount: [
          existing?.discount || '',
          [
            Validators.required,
            Validators.min(1),
            Validators.max(100)
          ]
        ],
        status: [existing?.status || false]
      })
    );
  }

  removePromoCode(index: number) {
    this.promoCodes.removeAt(index);
  }

  onCalendarDateChange(date: Date) {
    this.selectedDate = date;
    this.showError = false;
  }

  onCheckboxChange(event: Event) {
    this.isChecked = (event.target as HTMLInputElement).checked;

    if (!this.isChecked) {
      this.selectedDate = null;
      this.showError = false;
    }
  }

  savePromotion(): void {
    console.log(' this.businessProfileData',  this.businessProfileData)
    if (!this.isChecked) {
      // Checkbox nije čekiran → briši promociju (reset)
      this.businessProfilesHttpService
        .disablePromotion(this.businessProfileData.id)
        .subscribe({
          next: (res: any) => {
            this.businessProfileData = res.data;
            this.editBusinessProfileForm.patchValue(this.businessProfileData);
            this.selectedDate = null;
            this.showError = false;
            this.toastService.success(res.message);
          },
          error: (err: any) => {
            const message =
              err?.error?.message ||
              err?.message ||
              'Došlo je do greške';
            this.toastService.warning(message);
          }
        });
      return;
    }

    if (!this.selectedDate) {
      this.showError = true;
      return;
    }

    const payload = {
      ends_at: this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd')
    };

    if (this.businessProfileData?.promotion_active) {
      this.businessProfilesHttpService
        .updatePromotion(payload, this.businessProfileData.id)
        .subscribe(this.promotionObserver());
    } else {
      this.businessProfilesHttpService
        .enablePromotion(payload, this.businessProfileData.id)
        .subscribe(this.promotionObserver());
    }
  }

  private promotionObserver() {
    return {
      next: (res: any) => {
        this.businessProfileData = res.data;
        this.editBusinessProfileForm.patchValue(this.businessProfileData);
        this.toastService.success(res.message);
      },
      error: (err: any) => {
        const message =
          err?.error?.message ||
          err?.message ||
          'Došlo je do greške';
        this.toastService.warning(
          message,
          err?.error?.errors?.ends_at ?? null
        );
      }
    };
  }

  initInnerForm(data: any) {
    this.isChecked = data.promotion_active;
    this.selectedDate = data.promotion_ends_at
      ? new Date(data.promotion_ends_at)
      : null;
  }

  validate360Ratio(imageUrl: string, file: File): void {
    const img = new Image();

    // img.onload = () => {
    //   const ratio = img.width / img.height;
    //
    //   // if (Math.abs(ratio - 2) > 0.05) {
    //   //   this.error360 = `Slika ${file.name} mora biti u odnosu 2:1.`;
    //   //   URL.revokeObjectURL(imageUrl);
    //   //   return;
    //   // }
    //
    //   // ✅ prihvati sliku
    //   this.image360Urls.push({
    //     fullPath: imageUrl,
    //     file
    //   });
    //
    //   this.editBusinessProfileForm.controls.images_360.patchValue(this.image360Urls);
    // };
    this.image360Urls.push({
      fullPath: imageUrl,
      file
    });

    this.editBusinessProfileForm.controls.images_360.patchValue(this.image360Urls);
    img.src = imageUrl;
  }

  on360FileChange(event: Event): void {
    console.log('BOOOOOOOOOOOOOOOOO')
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const files = Array.from(input.files);

    files.forEach(file => {
      // tip
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/jpg'
      ) {
        this.error360 = 'Dozvoljeni su samo JPG i PNG formati.';
        return;
      }

      // veličina
      // if (file.size > 10 * 1024 * 1024) {
      //   this.error360 = `Slika ${file.name} je veća od 10MB.`;
      //   return;
      // }

      const objectUrl = URL.createObjectURL(file);
      // this.validate360Ratio(objectUrl, file);
      this.image360Urls.push({
        fullPath: objectUrl,
        file
      });
    });
    this.editBusinessProfileForm.controls.images_360.patchValue(this.image360Urls);
    input.value = '';
  }

}
